import { State } from 'widgets/friends-referral/root/root.reducers';
import { connect } from 'react-redux';
import { ICategory } from '@sitegen/common/types/faq';

import FAQ from './faq.component';

export interface IStateProps {
    readonly faqData: Array<ICategory>;
    readonly activeLanguageCode: string;
}

const mapStateToProps = (state: State): IStateProps => ({
    activeLanguageCode: state.language.activeLanguageCode,
    faqData: state.config.friendsReferral?.faq ?? []
});

export default connect(mapStateToProps)(FAQ);
